module.exports = __webpack_public_path__ + "static/img/background.8ca9eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.png
// module id = cf+J
// module chunks = 9